import { CAT_SAMPLE_CONDITIONS } from 'App/utils/Collections';

export default {
  category: CAT_SAMPLE_CONDITIONS,
  filters: [],
};
